import { useSelector } from "react-redux";
import useQueryParams from "../../utils/useQueryParams";

export function useConversationMiniToggleVisible() {
  const { token } = useQueryParams();
  const me = useSelector((state) => state.user.me);

  return Boolean(me && me.id && me.id.length > 8 && !token);
}

export const ROOM_MINI_TOGGLE_RESERVE_PX = 72;
export const ROOM_MINI_TOGGLE_RESERVE_MINI_PX = 54;
